(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/casino-react/page-category-games-standalone/assets/javascripts/root-lb.js') >= 0) return;  svs.modules.push('/components/casino-react/page-category-games-standalone/assets/javascripts/root-lb.js');

'use strict';

const {
  PageCategoryGamesStandalone
} = svs.components.casino_react.pageCategoryGamesStandalone;
const {
  baseUrl
} = svs.core.data;
const {
  BrowserRouter
} = ReactRouterDOM;
const {
  Provider
} = ReactRedux;
const {
  store
} = svs.components.casino_react.casinoStore;

function Root(_ref) {
  let {
    isLiveCasino,
    currentCategory,
    currentCategoryList
  } = _ref;
  return React.createElement("div", {
    className: "theme-lb-casino"
  }, React.createElement(BrowserRouter, {
    basename: baseUrl
  }, React.createElement(Provider, {
    store: store
  }, React.createElement(PageCategoryGamesStandalone, {
    currentCategory: currentCategory,
    currentCategoryList: currentCategoryList,
    isLiveCasino: isLiveCasino,
    renderSubHeader: true
  }))));
}
setGlobal('svs.components.casino_react.pageCategoryGamesStandalone.RootLb', Root);

 })(window);